import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PackageRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRedirect = async () => {
      try {
        const response = await fetch(`${API_URL}/api/seo/package-redirect/${id}`);
        
        if (!response.ok) {
          setError('Pachetul nu a fost găsit');
          return;
        }
        
        const data = await response.json();
        
        // 301 redirect to SEO URL
        navigate(data.redirect_url, { replace: true });
      } catch (err) {
        setError('Eroare la încărcarea pachetului');
      }
    };

    if (id) {
      fetchRedirect();
    }
  }, [id, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-navy flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-4">{error}</h1>
          <a href="/" className="text-gold hover:underline">Înapoi la pagina principală</a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center">
      <div className="w-12 h-12 border-4 border-gold border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
